export default __webpack_public_path__ + "static/media/ecommerceInstructions.871d915b.png";